// used by CableReady in stimulus reflex controllers to change the current page.
document.addEventListener('redirectToPath', function (event) { 
	Turbo.visit(event.detail.path)
	}
)
